import {
  View,
  Text,
  Image,
  Dimensions,
  TouchableOpacity,
  TextInput,
  KeyboardAvoidingView,
  ActivityIndicator,
  RefreshControl,
} from "react-native";
import React, { useEffect } from "react";
import MyView from "../../components/custom/MyView";
import {
  danger,
  gray,
  kalbasiMaybe,
  lightBlue,
  lighterBlue,
  primary,
  white,
} from "../../colors";
import { consultationDoctor, kidsWithDoctor, tutorial } from "../../imports";
import MyText from "../../components/custom/MyText";
import { FlatList, ScrollView } from "react-native-gesture-handler";
import WelcomeUser from "../../components/home/WelcomeUser";
import translate from "../../functions/translate";
import Wallet from "../../components/home/Wallet";
import GrowTest from "../../components/home/GrowTest";
import ASQ3Test from "../../components/home/ASQ3Test";
import ASQSE2Test from "../../components/home/ASQSE2Test";
import ADHDTest from "../../components/home/ADHDTest";
import LearningSlider from "../../components/home/LearningSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  changeHeaderColor,
  showBackButton,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import SelectIcon from "../../assets/svg/SelectIcon";
import MyButton from "../../components/custom/MyButton";
import { LinearGradient } from "expo-linear-gradient";
import SectionDropdown from "../../components/custom/SectionDropdown";
import { AntDesign } from "@expo/vector-icons";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Dropdown from "../../components/custom/Dropdown";
import DoctorCard from "../../components/consultation/DoctorCard";
import TutorialItem from "../../components/tutorial/TutorialItem";
import { useState } from "react";
import getTutorialsOfCategory from "../../api/tutorial/getTutorialsOfCategory";

export default function TutorialCategory(props) {
  const navigation = useNavigation();
  const { route } = props;
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [refreshing, setRefreshing] = useState(true);
  const [properties, setProperty] = useState({
    page: 1,
    limit: 1000,
  });
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (refreshing) {
      getTutorialsOfCategory(
        route.params.id,
        properties.limit,
        properties.page,
        main.rtl ? "FA" : "EN"
      ).then(({ data }) => {
        setRefreshing(false);

        if (data.status === 200) {
          setItems(data.data);
        }
      });
    }
  }, [refreshing, properties]);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(white));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  return (
    <FlatList
      showsVerticalScrollIndicator={false}
      style={{}}
      refreshing={refreshing}
      onRefresh={() => {
        setRefreshing(true);
        setProperty((prev) => ({ ...prev, page: 1 }));
      }}
      ListFooterComponent={() => <View style={{ height: 200 }}></View>}
      onEndReached={() =>
        setProperty((prev) => ({ ...prev, page: prev.page + 1 }))
      }
      ListHeaderComponent={
        <View style={{ alignItems: "center" }}>
          <View
            style={{
              height: Dimensions.get("window").height,
              marginTop: -1 * Dimensions.get("window").height,
              backgroundColor: white,
              width: "100%",
              zIndex: -1000,
            }}
          ></View>
          <View style={{ alignItems: "center" }}>
            <View style={{ backgroundColor: white }}>
              <View
                style={{
                  backgroundColor: white,
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  width: Dimensions.get("screen").width,
                  minHeight: 200,
                  flexDirection: "row",
                  paddingHorizontal: 10,
                }}
              >
                <View style={{ flex: 4.5 }}>
                  <View>
                    <MyText
                      style={{
                        fontSize: 30,
                        marginHorizontal: 10,
                        color: "#504E4E",
                      }}
                    >
                      {translate("tutorials of parents")}
                    </MyText>
                  </View>
                  <View
                    direction={main.rtl ? "rtl" : "ltr"}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  ></View>
                </View>
                <View style={{ flex: 4 }}>
                  <Image
                    source={tutorial}
                    style={{ width: "100%", height: 320 }}
                    resizeMode="contain"
                  />
                </View>
              </View>
            </View>
          </View>

          <View
            style={{
              marginTop: 10,
              width: "94%",
              borderWidth: 1,
              borderColor: primary,
              borderRadius: 10,
              padding: 10,
              alignItems: "center",
              flexDirection: "row",
              paddingHorizontal: 15,
            }}
          >
            <MyText style={{ color: gray, marginHorizontal: 2 }}>
              {translate("tutorial")}
            </MyText>
            <MyText style={{ color: gray, marginHorizontal: 2 }}>-</MyText>
            <MyText style={{ color: gray, marginHorizontal: 2 }}>
              {route.params.name}
            </MyText>
          </View>
        </View>
      }
      data={items}
      numColumns={2}
      horizontal={false}
      contentContainerStyle={{ alignItems: "center" }}
      renderItem={({ item }) => (
        <TutorialItem
          categoryId={route.params.id}
          title={main.rtl ? item.titleFa : item.titleEn}
          type={item.type}
          url={item.picURl}
          likes={item.cLike}
          image={item.picURl}
          id={item.id}
          store={item.store}
          kind={item.kind}
          bought={item.isBuy}
          setRefreshing={setRefreshing}
        />
      )}
    />
  );
}
